import COLORS from './colors';

const customerByConversationsChartConfig = {
  name: 'customers_by_conversations',
  title: 'Conversation Frequency',
  metric: 'customers_by_conversations',
  linesColor: COLORS.blue,
  downloadUsingLineLabels: false,
  lines: {
    customers_by_conversations: {
      label: 'Conversations',
      position: 1,
      color: COLORS.blue,
    },
  },
};

export default customerByConversationsChartConfig;
